import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const apiUrl = import.meta.env.VITE_APP_API;

const baseQuery = fetchBaseQuery({
    baseUrl: apiUrl,
    prepareHeaders: (headers) => {
        const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))?.token?.access;
        if (access_token) {
            headers.set("Authorization", `Bearer ${access_token}`);
        }
        return headers;
    },
});

export const smsApi = createApi({
    reducerPath: "smsApi",
    baseQuery,
    endpoints: (builder) => ({
        getSmsHistory: builder.query({
            query: ({
                ordering = "-created_at",
                page = 1,
                per_page = 100,
                search = "",
                created_at__gte = "",
                created_at__lte = ""
            } = {}) => ({
                url: `/api/account/sms_history/`,
                params: {
                    page,
                    per_page,
                    search,
                    created_at__gte,
                    created_at__lte,
                    ordering
                },
            }),
        }),
    }),
});

export const { useGetSmsHistoryQuery } = smsApi; 